import { Logger } from "../logger";
import { Money, Zero } from "../money";
import { FLOCK_SKU_PREFIX, SalesItemTypes } from "@qqcw/qqsystem-types";
const {
  trace
} = new Logger("Util");
export function convertSalesItemToOrderItem(salesItem, orderItem = {}) {
  return Object.assign(Object.assign(Object.assign({}, salesItem), {
    orderedQty: "1"
  }), orderItem);
}
export function getBalanceDueFromOrder(order) {
  return order ? new Money(order.orderTotal || "0").subtract(getTotalPaymentFromOrder(order)) : Zero;
}
export function getTotalPaymentFromOrder(order) {
  if (!order || !order.payments || !order.payments.length) {
    return Zero;
  }
  return Money.sum(...order.payments.map(payment => payment.paymentAmount));
}
export function getChangeDueFromOrder(order) {
  if (!order || !order.payments || !order.payments.length || getBalanceDueFromOrder(order).isGreaterThan(0)) {
    return Zero;
  }
  return Money.min(Money.max(0, getTotalPaymentFromOrder({
    payments: order.payments.filter(payment => Money.isPositive(payment.paymentAmount || 0))
  }).subtract(order.orderTotal || 0)), getCashTenderedFromOrder(order));
}
export function getCashTenderedFromOrder(order) {
  if (!order || !order.payments || !order.payments.length) {
    return Zero;
  }
  return Money.sum(...order.payments.filter(payment => payment.paymentType === "CASH" && Money.isPositive(+(payment.paymentAmount || 0))).map(payment => payment.paymentAmount));
}
export function addComputedPropertiesToOrder(order) {
  return Object.assign(Object.assign({}, order), {
    hasAuthorizedCreditCardPayment: hasAuthorizedCreditCardPayment(order),
    hasPaidCreditCardPayment: hasPaidCreditCardPayment(order),
    hasTokenizedCreditCardPayment: hasTokenizedCreditCardPayment(order),
    hasFlockAddon: hasFlockAddon(order),
    hasWashItem: hasWashItem(order),
    hasSubscriptionItem: hasSubscriptionItem(order),
    hasMembershipItem: hasMembershipItem(order),
    canComplete: order ? canCompleteOrder(order) : false,
    cashTendered: order ? getCashTenderedFromOrder(order) : Zero,
    changeDue: order ? getChangeDueFromOrder(order) : Zero,
    balanceDue: order ? getBalanceDueFromOrder(order) : Zero
  });
}
export function hasAuthorizedCreditCardPayment({
  payments = []
} = {
  payments: []
}) {
  return !!payments.find(payment => payment.paymentType === "CREDIT" && payment.paymentStatus === "AUTHORIZED");
}
export function hasPaidCreditCardPayment({
  payments = []
} = {
  payments: []
}) {
  return !!payments.find(payment => payment.paymentType === "CREDIT" && payment.paymentStatus === "PAID");
}
export function hasTokenizedCreditCardPayment({
  payments = []
} = {
  payments: []
}) {
  return !!payments.find(payment => payment.paymentType === "CREDIT" && payment.paymentStatus === "TOKENIZED");
}
export function hasMembershipItem({
  items = []
} = {
  items: []
}) {
  return !!items.find(item => item.itemType === SalesItemTypes.Membership);
}
export function hasSubscriptionItem({
  items = []
} = {
  items: []
}) {
  return !!items.find(item => item.itemType === SalesItemTypes.Subscription);
}
export function hasFlockAddon({
  items = []
} = {
  items: []
}) {
  return !!items.find(item => item.itemType === SalesItemTypes.Subscription && !!item.sku.match(FLOCK_SKU_PREFIX));
}
export function hasWashItem({
  items = []
} = {
  items: []
}) {
  return !!items.find(item => item.itemType === SalesItemTypes.WashPackage);
}
export function calculateOrderType(items) {
  if (items.some(({
    orderedQty
  }) => +orderedQty < 0)) {
    return "REFUND";
  }
  trace("calculateOrderType", "items", items);
  const newMembershipItem = items.find(item => item.itemType === "MEMBERSHIP" || item.itemType === "SUBSCRIPTION" && !(item.sku && item.sku.match(FLOCK_SKU_PREFIX)));
  if (newMembershipItem) {
    return "NEWMEMBERSHIP";
  }
  const flockAddon = items.find(item => !!item.sku && !!item.sku.match(FLOCK_SKU_PREFIX));
  if (flockAddon) {
    return "ADDMEMBERSHIP";
  }
  return "STORE";
}
export function canCompleteOrder({
  items = [],
  holds = []
}, error) {
  if (error || !(items || []).length || (holds || []).length) {
    return false;
  }
  return true;
}
